export const apiUrlparts = {

    // Regions URLs
    installationcenterList: 'api/location?',
    installationcenterGet: 'api/location/',
    installationcenterPost: 'api/commercials',
    installationcenterTypes: 'api/commercials/location-types',
    locationPost: 'api/location',

    // Regions URLs
    coldstoreList: 'api/cold-stores?',
    coldstoreGet: 'api/cold-stores/',
    coldstorePost: 'api/cold-stores',


    // Regions URLs
    regionList: 'api/regions?',
    regionGet: 'api/regions/',
    regionPost: 'api/regions',

    // Site URLs
    siteList: 'api/sites?',
    siteGet: 'api/sites/',
    sitePost: 'api/sites',
    siteListbyRegion: 'api/sites?',

    // Profile URLs
    profileList: 'api/profile?',
    profileGet: 'api/profile/',
    profilePost: 'api/profile',

    // Profile URLs
    profileTypeList: 'api/profile/type?',
    profileTypeGet: 'api/profile/type/',
    profileTypePost: 'api/profile/type',

    // Devices URLs
    deviceList: 'api/device/filter?',
    deviceGet: 'api/device/',

    // Device Order URLs
    deviceOrder: 'api/device/order',
    deviceOrderList: 'api/device/order?',
    deviceInventory: 'api/device/inventory',

    // Device Type URLs
    deviceType: 'api/device/types',
    deviceSubType: 'api/device/sub-type',
    deviceGroup: 'api/device/group',

    // Sensor URLs
    sensorProfile: 'api/device/sensor-profile',

    // Customer Urls
    customerGet: 'api/customer/',
    customerList: 'api/customer?',
    customerApprove: 'api/customer/approve',
    customerPost: 'api/customer',

    //onboarding URLs
    onboardPost:'api/onboard',
    registerCustomer:'api/onboard/register-customer',
    getResultTypes: "api/onboard/result-type",
    updateAnalysisConfig: "api/onboard/update-configuration",
    
    // users URLs
    userGet: 'api/user/',
    userList: 'api/user?',
    userRoleGet: 'api/role',
    changePassword:"api/user/changePassword",
    // Commodity URLs
    subcriptionGet: 'api/commodity/category/subscription',
    commodityGet: 'api/commodity/categories',
    commodityGetWithVariety: 'api/commodity/dictionary',
    commodityCategory: 'api/commodity',
    customeCategory: 'api/commodity/categories?',
    customerSelectedCommodities:'api/commodity/by-customer?',
    customerCommoditiesforReport:'api/report/commodity-list?',
    commodityConfigV2: 'api/commodityconfig/v2/',
    commodityVaraites: 'api/commodity/varieties',
    commodityVariety: 'api/commodity/variety?',
    commodityAnalytics: 'api/analytics/scan-analytics',
    commodityList: 'api/commodity/list',
    clientListBasedOnCommodity: 'api/range/by-commodity?',
    clientBasedAnalyticList: 'api/range?',
    stateList: 'api/states/scan-based',
    commodityScanBased: 'api/commodity/scan-based',
    vendorScanBased: 'api/icompass/v1/vendors/scan-based',
    analyticTabData:'api/analytics/links',
    districtList:'api/location/by-state',
    seasonList:'api/seasons/all-season-details',
    deviceCommodities:'api/commodity/device',
    // Quantity Details URLs
    collectionDetails: 'api/analytics/quantity-details-id',
    totalcollections: 'api/analytics/total-collections',
    collectionDetailsreactive: 'collections',
    totalcollectionsreactive: 'collections',
    quantityDetails: 'api/analytics/quantity-details',
    varianceRate: 'api/scan/filter/variance-average',
    varianceRateReactive: 'collections',
    acceptanceRate: 'api/scan/filter/accepted-average',
    acceptanceRateReactive: 'collections/accepted',
    scanCount: 'api/scan/filter/daily/scan/scount',
    scanCountReactive: 'collections/scount',
    installationCenterListonLanding:'api/analytics/location-details',
    installationCenterListonLandingReactive:'collections/location',
    putScan:'api/data/edit/',
    removeScan:'api/scan/delete/',
    // Provision URLs
    commercialLocationsGet: 'api/commercials/location?',
    deviceProvision: 'api/device/provision/',
    deviceProvisionMultiple: 'api/device/provision-devices/',

    deviceTypeList: 'api/device/types/list',
    clientHistoryTemplate: 'api/scan/history-templates',
    clientCommoditiesAnalytics: 'api/report/analysis-list?',
    getReport: 'api/report?',
    clientConfigurationData: 'api/client-config/meta-data?',
    clientConfigurationJsonData: 'api/client-config/details?',
    clientConfigurationSave: 'api/client-config',
    clients3folderSearch: 'api/client-config/s3-folders?',
    analysisAndVariation: 'api/client-config/analysis-params?',
    commodityConfiguration: 'api/client-config/analysis-config?',
    postClientCommodityConfig:'api/client-config/analysis-config',
    scanDetailTemplate:'api/scan/templates?',

    // Profile Food type URLs
    profileFoodTypeList: 'api/profile/food/type?',
    profileFoodTypeGet: 'api/profile/food/type/',
    profileFoodTypePost: 'api/profile/food/type',

    //
    scanHistory: 'api/scan/history?',
    scanHistoryv2: 'api/scan/v2/history?',
    scanReactiveHistory: 'scan/history/v2/response?',
    scanDetail: 'api/scan/detail/v2?',
    scanQualityCheckDetail: 'api/customizedFeatures/dtr/',
    scanResult:'api/customizedFeatures/analytics/',
    scanDetailReactive: 'scan/analysis/',
    scanPDFDownload: 'api/chemical/device/visio/download/pdf/',
    qcscanPDFDownload: 'api/customizedFeatures/downloadPdf/',
    scanImage: 'api/chemical/device/download-physical/image/',
    scanQCOutboundImage: 'api/customizedFeatures/image/',
    scanDropDown: 'api/analytics/commodity/devices',
    scanImageDownload: 'api/chemical/device/download-physical/download/',
    scanInfo: 'api/scan/metadata?',
    scanQualityCheckInfo: 'api/customizedFeatures/dtr/',
    scanInfoReactive: 'scan/data/',
    scanStatusChange: 'api/scan/approve',
    scanList: 'api/scan/lab/results?',
    //allScanData: 'api/export',
    allScanData: 'api/export/v2',
    compositescans:'api/compositescan/getAssociation?',
    duplicatescans:'api/scan/duplicate-scan-history?',
    geteditablescan:'api/data/editable-scan?',
    getscanbysampleid:'api/data?',
    // Farmer
    farmerList: 'api/analytics/client/list',
    farmerMaxMin: 'api/analytics/client/new',

    // logout
    userLogout: '/api/logout',

    // superAdmin
    devicesWidget: 'api/device/widget?',
    devicesInventoryWidget: 'api/device/unassigned?',
    customerWidget: 'api/customer/count?',
    usersWidget: 'api/user/count?',
    poDetails: 'api/device/po-count?',

    // Subscription Detail
    subscriptionPackageDeviceType: 'api/device/types?',
    subscriptionDetail: 'api/subscription?',
    packageDetailByDeviceType: 'api/subscription/package?',
    buyNewPackage: 'api/subscription/buy/commodity?',
    upgradeExistingPackage: 'api/subscription/licence/renew?',
    newPackage: 'api/subscription/buy/licence?',
    renewLicense: 'api/subscription/licence/renew?',

    // Analysis URL
    location: 'api/location',
    client: 'api/customer/clients',
    locationWithDevices: 'api/location/location-with-devices',


    //Shade Card
    shadecardcustomercommodity:'api/shade-card/commodity/',
    shadecardputparametersvalue:'api/shade-card/commodity/',
    shadecardimages:'api/shade-card/images',
    shadecardmatrix:'api/shade-card/matrix',
    shadecardPostMatrix:'api/shade-card/postmatrix/',
    shadecardSaveImage:'api/shade-card/images/',

    //verify scan
    verifyScan : 'api/hedera/verify?',
    //get hedera transactions 
    hederaTransactions : 'api/hedera/get-hedera-transactions',

    // Supplier/Surveyor URLs - Based on actual backend controller
    surveyorCreate: 'api/surveyor/create',
    surveyorGetAll: 'api/surveyor',
    surveyorGetByEmail: 'api/surveyor/email',
    surveyorUpdate: 'api/surveyor',
    supplierGetById: 'api/surveyor/supplier',
    operatorSuppliers: 'api/surveyor/operator', 
    operatorSupplierById: 'api/surveyor/operator-supplier',
    getSuppliers: 'api/suppliers',

      //Tea
      owntealist: 'api/section?',
      postsection: 'api/section',
      deletesection: 'api/section',
      getsection: 'api/section',
      getGardens:'api/garden?',
      getSardaars:'api/sardaar?',
      exportData: 'api/data/export',   //not
      allSections: 'api/section-details/all',
      estateDetails: 'api/section-details/own',
      supplierDetails: 'api/section-details/bought',
      // Tea
      boughttealist: 'api/supplier?',
      postsupplier: 'api/supplier',
      deletesupplier: 'api/supplier',
      getsupplier: 'api/supplier',
  
      postfarmer:'api/farmer',
      deletefarmer:'api/farmer',
      verhicleapi:'api/vehicle',
      estateContacts: 'api/section-details/estate-contacts?',
      supplierContacts: 'api/section-details/supplier-contacts?',
  
      downloadEstateContacts: 'api/csv/download-own-leaf-data',
      uploadEstateContacts: 'api/csv/upload-own-leaf-data',
  
      downloadSupplierContacts: 'api/csv/download-bought-leaf-data',
      uploadSupplierContacts: 'api/csv/upload-bought-leaf-data',

      // Grafana URLs
      grafanaPanels: 'api/grafana/panels',
      grafanaDashboards: 'api/grafana/dashboards',
      grafanaLogin: 'api/grafana/login',

      // ICompass Config (provides vendorDetails for vendor filter)
      iCompassConfig: 'api/icompass/v1/config',

      downloadFactoryContacts: 'api/csv/download-estate-device-data',
      uploadFactoryContacts: 'api/csv/upload-estate-device-data',
};
